export default {
  common: {
    login: "Нэвтрэх",
    loginRequired: "Нэвтэрх шаардлагатай",
    logout: "Гарах",
    signup: "Бүртгүүлэх",
    home: "Нүүр",
    search: "Хайх",
    cancel: "Цуцлах",
    confirm: "Баталгаажуулах",
    save: "Хадгалах",
    delete: "Устгах",
    edit: "Засах",
    welcome: "Тавтай морилно уу",
    loading: "Ачаалж байна...",
    error: "Алдаа гарлаа",
    noData: "Өгөгдөл байхгүй",
    number: "Дугаар",
    title: "Гарчиг",
    date: "Огноо",
    type: "Төрөл",
    status: "Төлөв",
    canceled: "Цуцлагдсан",
    approved: "Зөвшөөрөгдсөн",
    rejected: "Хүлээгдэж байна",
    waiting: "Хүлээгдэж байна",
    reset: "Шинэчлэх",
    submit: "Илгээх",
    success: "Амжилттай",
    failed: "Амжилтгүй",
    amountMustBeGreaterThan0: "Дүн 0-аас ихээгүй байх шаардлагатай",
  },
  header: {
    announcement: "Бид одоо нээлтээ хийлээ!",
    login: "Нэвтрэх",
    register: "Бүртгүүлэх",
    casino: "АМЬД КАЗИНО​",
    slotGame: "СЛОТ ТОГЛООМУУД​",
    liveSports: "Шууд Спорт",
    cashIn: "ДИПОЗИТ ОРЛОГО ХИЙХ​",
    cashOut: "МӨНГӨ ТАТАХ​",
    needHelp: "Тусламж хэрэгтэй юу?",
    honorific: "",
    chip: "Чипс",
    point: "Оноо",
    partnerPage: "Харилцагчийн хуудас",
  },
  slider: {
    casino: {
      subtitle: "ШОГУН АМЬД КАЗИНО​",
      title1: "АМЬД КАЗИНО​",
      title2: "БҮХ ТОГЛОГЧДОД ​  СЭТГЭЛ ХАНАМЖИЙН ​  БАТАЛГААТАЙ ",
    },
    slot: {
      subtitle: "ШОГУН СЛОТ ТОГЛООТ​",
      title1: "АМЬД СЛОТ​",
      title2: "БҮХ ТОГЛОГЧДОД ​  СЭТГЭЛ ХАНАМЖИЙН ​  БАТАЛГААТАЙ ",
    },
    sports: {
      subtitle: "ШОГУН СПОРТ",
      title1: "Шууд Спорт",
      title2: "БҮХ ТОГЛОГЧДОД ​  СЭТГЭЛ ХАНАМЖИЙН ​  БАТАЛГААТАЙ ",
    },
  },
  homePage: {
    casino: {
      title: "АМЬД КАЗИНО​",
      subtitle: "ШОГУН КАЗИНО",
    },
    slot: {
      title: "ШОГУН СЛОТ​",
      subtitle: "ШОГУН СУГАЛАА",
    },
  },
  gameList: {
    showAll: "Бүгдийг харуулах",
    underMaintenance: "Засах ажил явагдаж байна",
  },
  board: {
    faq: {
      subtitle: "Түгээмэл асуултууд",
      title: "FAQ​",
      viewMore: "Нэмэлт ТАВ-уудыг харах",
      items: [
        {
          id: 1,
          title: "‘SHOGUN’ ГЭЖ ЮУ ВЭ?",
          content: "‘SHOGUN’ бол 100 гаруй өөр өөр төрлийн Казино болон Слот тоглоомуудыг багтаасан,веб болон мобайл хэлбэрээр үйлчилгээ үзүүлдэг дэлхийд баталгаажсан платформ юм​."
        },
        {
          id: 2,
          title: "ХЭР АЮУЛГҮЙ ВЭ?",
          content: "Манайх гишүүдийн хувийн мэдээлэл болон хөрөнгийг хамгаалахын тулд хамгийн сүүлийн үеийн аюулгүй байдлын системийг ашигладаг ба бүх гүйлгээг шифрлэж шудрага тоглоомын орчныг хангахын тулд тогтмол аудит хийдэг​."
        },
        {
          id: 3,
          title: "ХЭР ИХ ТОГЛООМТОЙ ВЭ?",
          content: "Манайх 100 гаруй өөр өөр төрлийн тоглоомтой ба үүнд Казино, Слот, Мини тоглоом зэргийг багтаасан байгаа."
        },
        {
          id: 4,
          title: "ХЭРХЭН ТАТАЛТ ЦЭНЭГЛЭЛТ ХИЙХ ВЭ?",
          content: "Олон төрлийн сонголтоор Таталт болон Цэнэглэлтээ хийж болно.​ Бүх төрлийг Банкны дансаар шилжүүлэг хийж болхоос гадна Криптовалютаар /USDT/ мөн Тататлт, Цэнэглэлт хийх боломжтой. Таталт, Цэнэглэлт нь 5-10 минутын дотор явагдана."
        }
      ]
    },
    notice: {
      subtitle: "МЭДЭГДЭЛ​",
      title: "СҮҮЛИЙН МЭДЭГДЭЛ​",
      viewMore: "НЭМЭЛТ МЭДЭГДЭЛ​ ХАРАХ​",
    },
  },
  footer: {
    ourPartners: "Манай түншүүд",
    copyright: "Зохиогчийн эрх 2024 ШОГУН. Бүх эрх хуулиар хамгаалагдсан",
    casino: "Шууд Казино",
    slotGame: "Сугалааны тоглоомууд",
    miniGame: "Жижиг тоглоомууд",
  },
  auth: {
    login: "Нэвтрэх",
    register: "Бүртгүүлэх",
    username: "Хэрэглэгчийн нэр",
    password: "Нууц үг",
    passwordConfirm: "Нууц үгээ баталгаажуулна уу",
    passwordMismatch: "Нууц үг таарахгүй байна",
    rememberPassword: "Нууц үгээ санах",
    captcha: "CAPTCHA текстийг оруулна уу",
    referrer: "Урилгын код",
    phone: "Утасны дугаар",
    nameBank: "Банкны нэр",
    numberBank: "Дансны дугаар",
    userBank: "Дансны эзэн",
    loginFailed: "Нэвтрэх амжилтгүй",
    registerFailed: "Бүртгэл амжилтгүй",
  },
  maintenance: {
    title: "Удахгүй буцаж ирнэ!",
    message: "Систем засвартай байна. Тасалдлыг уучлаарай.",
  },
  homePopup: {
    selectList: "Жагсаалт сонгох",
    deposit: "ЦЭНЭГЛЭЛТ​",
    withdrawal: "ТАТАЛТ​",
    bankingHistory: "Банкны түүх",
    pointToChip: "Оноог Чипс рүү хөрвүүлэх",
    notice: "Мэдэгдэл",
    inquiry: "Асуулт",
    myInfo: "Миний мэдээлэл",
    betHistory: "Мөрийний түүх",
    faq: "ТАВ",
  },
  betting: {
    name: "Мөрийний нэр",
    game: "Тоглоом",
    type: "Төрөл",
    amount: "Дүн",
    date: "Огноо",
    status: {
      win: "ХОЖИЛ",
      lose: "ХОГИЛ",
      bet: "МӨР",
    },
  },
  deposit: {
    notice: "Оруулалтын мэдээллийг анхааралтай шалгана уу",
    info: "Оруулалт 5-10 минутын дотор боловсруулагдана",
    currentBalance: "Одоогийн үлдэгдэл",
    amount: "ЦЭНЭГЛЭЛТИЙН ДҮН​",
    usdtAmount: "USTD ЦЭНЭГЛЭЛТИЙН ДҮН​",
    requestAccount: "Оруулалтын данс хүсэх",
    requestUsdtAddress1: "Polygon USDT хаяг",
    requestUsdtAddress2: "Tron USDT хаяг",
    myWallet: "Миний Үүсгэгч",
    bottomNotice: "Тусламж хэрэгтэй бол үйлчилгээний төлөөлөгчтэй холбогдоно уу",
    title: "Оруулалт",
    normalDeposit: "Оруулалт",
    usdtDeposit: "USDT Оруулалт",
  },
  withdrawal: {
    notice: "Татан авалтын мэдээллийг анхааралтай шалгана уу",
    currentBalance: "Одоогийн үлдэгдэл",
    walletAddress: "ХЭТЭВЧНИЙ",
    amount: "ЦЭНЭГЛЭЛТИЙН ДҮН​",
    usdtAmount: "USTD ЦЭНЭГЛЭЛТИЙН ДҮН​",
    password: "Татан авалтын нууц үг",
    myWallet: "Миний Үүсгэгч",
    title: "Татан авалт",
    normalWithdrawal: "Оруулалт",
    usdtWithdrawal: "USDT Оруулалт",
  },
  banking: {
    bankAccountRequired: "Банкны дансны мэдээлэл шаардлагатай",
  },
  bankinghistory: {
    beforeBalance: "Өмнөх үлдэгдэл",
    requestAmount: "Хүсэлтийн дүн",
    afterBalance: "Дараах үлдэгдэл",
  },
  profile: {
    username: "Хэрэглэгчийн нэр",
    balance: "Үлдэгдэл",
    point: "Оноо",
    changePassword: "Нууц үг солих",
    currentPassword: "Одоогийн нууц үг",
    newPassword: "Шинэ нууц үг",
    confirmPassword: "Шинэ нууц үгээ баталгаажуулна уу",
    passwordChanged: "Нууц үг амжилттай солигдлоо",
    passwordMismatch: "Нууц үг таарахгүй байна",
    invalidPassword: "Одоогийн нууц үг буруу байна",
  },
  notice: {
    unread: "Уншаагүй",
    read: "Уншсан",
  },
  inquiry: {
    title: "Асуултын гарчиг",
    select: "Асуултын төрлийг сонгоно уу",
    writer: "Зохиогч",
    placeholder: "Асуултаа оруулна уу (дээд тал нь 100 тэмдэгт)",
    types: {
      deposit: "Оруулалтын асуулт",
      withdrawal: "Татан авалтын асуулт",
      account: "Дансны хүсэлт",
      other: "Бусад асуулт",
    },
    reply: "Хариу",
    send: "Илгээх",
    note: "Хариулт хүлээгдэж байна",
    showMore: "Илүү ихийг харуулах",
    showLess: "Багасгах",
    newInquiry: "Шинэ асуулт",
    delete: "Устгах",
    deleteConfirmation: "Энэ асуултыг устгахдаа итгэлтэй байна уу?",
  },
  point: {
    currentBalance: "Одоогийн оноо",
    amount: "Хувиргах дүн",
    enterAmount: "Дүнг оруулна уу",
    password: "Нууц үг",
    enterPassword: "Нууц үгээ оруулна уу",
    convert: "Хувиргах",
    invalidAmount: "Буруу дүн",
    convertSuccess: "Оноо амжилттай хувирлаа",
  },
};